/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/self-closing-comp */
import React, { useCallback, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BodyScan } from "@swan-admin/swan-web-component";
import {  MUSE_STATUS, STREAM_SCAN } from "../vars";
import { UserDetailsContext } from "../context/userDetails";
import {   handleGetUserDetails, handleScanTimeCapture } from "../utils/util";
import LoadingScreen from "./loadingScreen/LoadingScreen";

let interval;
function MeasurementStatus() {
	const { shopDomain, email,gender } = useContext(UserDetailsContext);
	const navigate = useNavigate();
	const [loading, setLoading] = useState(true);
	const [showDrawer, setShowDrawer] = useState(false);
	const toggleDrawer = useCallback(() => {
		setShowDrawer(false);
	}, [showDrawer]);

	const polling = useCallback(() => {
		let count = 0;
		interval = setInterval(async () => {
			count += 1;
			try {
				const res = await handleGetUserDetails();
				handleScanTimeCapture({ event: `${shopDomain}/body_scan_check`, email, type: "polling", data: JSON.stringify(res?.data) });
				if (res?.data?.isMeasured !== null) {
					clearInterval(interval);
					if (res?.data?.isMeasured) {
						handleScanTimeCapture({ event: `${shopDomain}/body_scan_check`, email, type: "completed", data: JSON.stringify(res?.data) });
						navigate(MUSE_STATUS);
					} else {
						handleScanTimeCapture({ event: `${shopDomain}/body_scan_check`,  email,type:"error", data: JSON.stringify(res?.data) });
						setShowDrawer(true);
					}
					setLoading(false);
				} else if (count >= 6) {
					handleScanTimeCapture({ event: `${shopDomain}/body_scan_check`, email, type: "polling_timeout" });
					clearInterval(interval);
					setShowDrawer(true);
				}
			} catch (err) {
				handleScanTimeCapture({ event: `${shopDomain}/body_scan_check`, email, type: "error" });
				console.log(err);
				clearInterval(interval);
				setShowDrawer(true);
			}
		}, 30000);
	}, [shopDomain, interval]);

	const getUserDetails = async () => {
		handleScanTimeCapture({ event: `${shopDomain}/body_scan_check`, email, type: "started" });
		try {
			const res = await handleGetUserDetails();
			console.log(res?.data);

			if (res?.data?.isMeasured === null) {
				polling();
			} else if (res?.data?.isMeasured) {
				handleScanTimeCapture({ event: `${shopDomain}/body_scan_check`, email, type: "completed", data: JSON.stringify(res?.data) });
				navigate(MUSE_STATUS);
			} else {
				handleScanTimeCapture({ event: `${shopDomain}/body_scan_check`, email, type: "completed", data: JSON.stringify(res?.data) });
				setShowDrawer(true);
				setLoading(false);
			}
		} catch (error) {
			handleScanTimeCapture({ event: `${shopDomain}/body_scan_check`, email, type: "error" });
			console.log(error);
		}
	};

	useEffect(() => {
		if (shopDomain) {
			getUserDetails();
		}
	}, [shopDomain]);
	useEffect(
		() => () => {
			clearInterval(interval);
		},
		[],
	);
	return (
		<>
			<div className="px-1 py-2 bg-[#FDFDFD] max-w-md mx-auto">
				{loading ? (
					<div className="flex top-0 !mt-0 left-0 z-[999] bg-opacity-80 bg-[#1b1b1b] fixed justify-center items-center w-full h-full">
						<LoadingScreen />
					</div>
				) : (
					<div></div>
				)}
			</div>
			{showDrawer && (
				<BodyScan
					isError
					userDetails={{gender}}
					onRetry={() => {
						toggleDrawer();
						// const params = new URLSearchParams(window.location.search);
						// params.set("isFaceScan", "true");
						navigate(STREAM_SCAN);
					}}
				/>
			)}
		</>
	);
}

export default MeasurementStatus;
